var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.documentType == 'BankOrder')?_c('span',[_vm._v("Banka Talimatı")]):(_vm.documentType == 'Contract')?_c('span',[_vm._v("Sözleşme")]):(_vm.documentType == 'General')?_c('span',[_vm._v("Genel")]):_c('i',{staticClass:"text-muted"},[_vm._v("Bilinmiyor")])])
}
var staticRenderFns = []

export { render, staticRenderFns }